"use client";

import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { FunnelBuildOutcomes, SHOP_EVENT_TYPES } from "@jurni/schemas";
import { useShopEvents } from "@/hooks/use-shop-events";
import { useAiOutcomeAnalytics } from "@/hooks/use-ai-outcome-analytics";
import { toastFunnelResult } from "@/components/funnel-result-toast";

export const useBriefBuildHandlers = () => {
  const queryClient = useQueryClient();
  const { briefBuildCompleted } = useAiOutcomeAnalytics();

  // Broadcast to the whole shop: keep every member's roadmap in sync as a brief settles.
  useShopEvents(SHOP_EVENT_TYPES.BRIEF_STATUS_CHANGED, ({ payload }) => {
    queryClient.invalidateQueries({ queryKey: ["brief", payload.briefId] });
    queryClient.invalidateQueries({ queryKey: ["briefs"] });
  });

  // Broadcast to the whole shop: keep every member's AI Recommendations CTA in sync as a
  // generation run starts/settles (manual trigger or scheduled run).
  useShopEvents(SHOP_EVENT_TYPES.SUGGESTION_RUN_CHANGED, () => {
    queryClient.invalidateQueries({
      queryKey: ["brief-suggestions-run-status"],
    });
    queryClient.invalidateQueries({ queryKey: ["brief-suggestions"] });
    queryClient.invalidateQueries({ queryKey: ["briefs"] });
  });

  // Targeted (server-side) at the user who triggered the build: only they toast.
  useShopEvents(SHOP_EVENT_TYPES.FUNNEL_BUILD_SETTLED, ({ payload }) => {
    if (payload.status === FunnelBuildOutcomes.SUCCEEDED) {
      briefBuildCompleted({
        brief_id: payload.briefId,
        funnel_id: payload.funnelId,
      });
      toastFunnelResult({
        title: `Funnel built from brief #${payload.briefId}`,
        subtitle: "Saved as draft",
        funnelId: payload.funnelId,
        name: payload.briefTitle,
      });
      return;
    }

    toast.error(
      `Funnel build failed · Brief #${payload.briefId}: ${payload.briefTitle}`,
      {
        description: "Please try generating the funnel again.",
      },
    );
  });
};
